// 一覧ページ
if (document.querySelector<HTMLFormElement>('[data-role="videos-select-form"]') !== null) {
  document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector<HTMLFormElement>('[data-role="videos-select-form"]');
    const hiddenFieldsContainer = document.getElementById('hidden-fields');

    if (!form || !hiddenFieldsContainer) return;

    const MAX_SELECTION = 5;

    // localStorage から選択済み動画IDを取得
    const selectedVideos: string[] = JSON.parse(localStorage.getItem('selectedVideos') || '[]').map(String);

    const checkboxes: HTMLInputElement[] = Array.from(document.querySelectorAll<HTMLInputElement>('.video-checkbox'));

    /**
     * hidden input を container に追加
     */
    const addHiddenInput = (postId: string) => {
      if (!hiddenFieldsContainer.querySelector<HTMLInputElement>(`#video-${postId}`)) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'videos[]';
        input.value = postId;
        input.id = `video-${postId}`;
        hiddenFieldsContainer.appendChild(input);
      }
    };

    /**
     * hidden input を container から削除
     */
    const removeHiddenInput = (postId: string) => {
      hiddenFieldsContainer.querySelectorAll<HTMLInputElement>(`#video-${postId}`).forEach(el => el.remove());
    };

    /**
     * localStorage 更新
     */
    const updateLocalStorage = () => {
      localStorage.setItem('selectedVideos', JSON.stringify(selectedVideos));
    };

    /**
     * MAX_SELECTION に達したら未チェックを disabled に
     */
    const updateDisabledState = () => {
      const checkedCount = checkboxes.filter(cb => cb.checked).length;
      checkboxes.forEach(cb => {
        if (!cb.checked) cb.disabled = checkedCount >= MAX_SELECTION;
      });
    };

    // ページロード時の復元
    selectedVideos.forEach(postId => {
      const checkbox = checkboxes.find(cb => cb.value === postId);
      if (checkbox) checkbox.checked = true;
      addHiddenInput(postId);
    });

    // ページロード時の disabled 状態更新
    updateDisabledState();

    // チェックボックス変更イベント
    checkboxes.forEach(cb => {
      cb.addEventListener('change', () => {
        const postId = cb.value;

        if (cb.checked) {
          // MAX_SELECTION を超える場合はチェックできない
          const checkedCount = checkboxes.filter(c => c.checked).length;
          if (checkedCount > MAX_SELECTION) {
            alert(`選択は最大 ${MAX_SELECTION} 件までです`);
            cb.checked = false;
            return;
          }

          addHiddenInput(postId);

          if (!selectedVideos.includes(postId)) {
            selectedVideos.push(postId);
            updateLocalStorage();
          }
        } else {
          removeHiddenInput(postId);

          const index = selectedVideos.indexOf(postId);
          if (index > -1) {
            selectedVideos.splice(index, 1);
            updateLocalStorage();
          }
        }

        updateDisabledState();
      });
    });
  });
}

// フォームページ
document.addEventListener("DOMContentLoaded", () => {
  const selectedVideosContainer = document.querySelector('[data-role="selected-videos"]') as HTMLElement | null;
  const cf7SelectedVideo = document.querySelector('#selected-video') as HTMLElement | null;

  if (!selectedVideosContainer || !cf7SelectedVideo) return;

  // ---------------------------------------------------
  // CF7 hidden input （selected_videos）を更新
  // ---------------------------------------------------
  const updateCf7HiddenField = () => {
    const hiddenField = document.querySelector<HTMLInputElement>('#selected_videos');
    if (!hiddenField) return;

    // 現在 #selected-video 内に入っている <p> のテキストを全部取得
    const texts: string[] = [];
    cf7SelectedVideo.querySelectorAll('p').forEach(p => {
      texts.push(p.textContent ?? "");
    });

    // 改行でまとめて1つの string として hidden input に入れる
    hiddenField.value = texts.join("\n");
  };

  // -----------------------------------------
  // 初期生成：selected-videos の hidden input から <p> を生成
  // -----------------------------------------
  const existingInputs = selectedVideosContainer.querySelectorAll<HTMLInputElement>('input[name="videos[]"]');

  existingInputs.forEach(input => {
    const postId = input.value;
    const title = input.dataset.title ?? "";
    const photoId = input.dataset.id ?? ""; // ← 追加：photo_id を取得

    const p = document.createElement("p");
    p.dataset.photoId = postId;

    // (photo_id) タイトル の形
    p.textContent = `(${photoId}) ${title}`;

    cf7SelectedVideo.appendChild(p);
  });
  updateCf7HiddenField();

  // ---------------------------------------------------
  // 削除ボタンの活性/非活性切り替え
  // ---------------------------------------------------
  const updateDeleteButtons = () => {
    const blocks = document.querySelectorAll<HTMLElement>('[data-post-id]');
    const count = blocks.length;

    blocks.forEach(block => {
      const btn = block.querySelector("button") as HTMLButtonElement | null;
      if (!btn) return;

      if (count <= 1) {
        btn.disabled = true;
        btn.classList.add("opacity-50", "cursor-default");
      } else {
        btn.disabled = false;
        btn.classList.remove("opacity-50", "cursor-default");
      }
    });
  };

  updateDeleteButtons();

  // ---------------------------------------------------
  // localStorage の配列を削除に同期
  // ---------------------------------------------------
  const removeFromLocalStorage = (postId: string) => {
    const stored = localStorage.getItem("selectedVideos");
    if (!stored) return;

    const arr = JSON.parse(stored) as string[];
    const newArr = arr.filter(id => id !== postId);
    localStorage.setItem("selectedVideos", JSON.stringify(newArr));
  };

  // ---------------------------------------------------
  // 削除ボタン処理
  // ---------------------------------------------------
  const photoBlocks = document.querySelectorAll<HTMLElement>('[data-post-id]');

  photoBlocks.forEach(block => {
    const postId = block.dataset.postId ?? "";
    const button = block.querySelector("button") as HTMLButtonElement | null;

    if (!button) return;

    button.addEventListener("click", () => {
      // 1. 一覧のブロックを削除
      block.remove();

      // 2. selected-videos 内 hidden input 削除
      const removeFromSelected = selectedVideosContainer.querySelector<HTMLInputElement>(
        `input[name="videos[]"][value="${postId}"]`
      );
      removeFromSelected?.remove();

      // 3. CF7 表示用の <p> を削除
      const removeFromCF7 = cf7SelectedVideo.querySelector<HTMLElement>(
        `[data-photo-id="${postId}"]`
      );
      removeFromCF7?.remove();

      // hidden も更新
      updateCf7HiddenField();

      // 4. localStorage 同期
      removeFromLocalStorage(postId);

      // 5. 削除ボタンの活性/非活性更新
      updateDeleteButtons();
      updateCf7HiddenField();
    });
  });
});
